import { GroupData, GroupMode } from '@bringg/types';

import { orderExplorerRootStore } from 'bringg-web/features/monitoring/order-explorer/stores/order-explorer-root-store';
import { orderExplorerGroupLoader } from 'bringg-web/features/monitoring/order-explorer/data/order-explorer-group-loader';

const changeMode = (groupMode: GroupMode) => {
	const orderExplorerStore = orderExplorerRootStore.getStore().orderExplorerStore;

	orderExplorerStore.tableDefinitionChange({ groupMode });
};

function toggleCollapseAll(isCollapsed: boolean) {
	if (isCollapsed) {
		collapseAll();
	} else {
		expandAll();
	}
}

async function toggleCollapse(group: GroupData, isCollapsed: boolean): Promise<void> {
	return isCollapsed ? collapse(group) : expand(group);
}

async function expand(group: GroupData) {
	const orderExplorerStore = orderExplorerRootStore.getStore().orderExplorerStore;

	if (!orderExplorerStore.isGroupPartiallyLoaded(group)) {
		await orderExplorerGroupLoader.load(group);
	}

	orderExplorerStore.toggleGroupCollapse(group.id, false);
}

function collapse(group: GroupData) {
	const orderExplorerStore = orderExplorerRootStore.getStore().orderExplorerStore;
	orderExplorerStore.toggleGroupCollapse(group.id, true);
}

function expandAll() {
	const orderExplorerStore = orderExplorerRootStore.getStore().orderExplorerStore;
	orderExplorerStore.toggleCollapseAll(false);
}

function collapseAll() {
	const orderExplorerStore = orderExplorerRootStore.getStore().orderExplorerStore;
	orderExplorerStore.toggleCollapseAll(true);
}

export const groupToggleService = { toggleCollapse, toggleCollapseAll, changeMode };
